/* eslint-disable import/order */
/* eslint-disable prettier/prettier */
import { createSelector } from "@reduxjs/toolkit";
import { exceptionApi } from "./api-slice";
import { IManageBaseListResponse, IManageBaseResponse } from '@bvi/api-interfaces/response/manage-base-data';

export const selectException = createSelector(
  (response?: IManageBaseListResponse) => response,
  (response) => (response?.success ? response.payload.data : []),
);

export const selectExceptionListResult = () =>
  exceptionApi.endpoints.getExceptionList.select();

export const selectExceptionResponse = (data?: IManageBaseResponse) => {
  if (!data?.success) {
    return [];
  }

  return data.payload.data;
};




